<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <router-link class="btn btn-primary" to="/ajouter-factureS">
          <i class="fa fa-plus-circle"></i>
          Ajouter facture
        </router-link>
      </div>
      <div class="d-flex align-items-center">
        <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input type="text" name="mot" v-model="searchTerm" @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0" placeholder="Rechercher une facture" />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>

    <!-- START -->
    <div class="card-body p-15 p-sm-20 p-md-25">
    <div class="col-md-12">
      <!-- <div class="row d-flex justify-content-start align-items-start text-center"> -->
      <div class="row ">
       
        <div class="col-md-5">
          <div class="form-group mb-15 mb-sm-20 mb-md-25">
            <label class="d-block text-black fw-semibold mb-10">
              Service
            </label>
            <Field v-model="_service" name="service" v-slot="{ field }">
              <Multiselect v-model="field.value" v-bind="field" :options="servicesOptions" :preserve-search="true"
                :multiple="false" :searchable="true" placeholder="Sélectionner le service" label="label"
                track-by="label" />
            </Field>
            <ErrorMessage name="service" class="text-danger" />
          </div>
        </div>


        <div class="col">
          <div class="form-group mb-15 mb-sm-20 mb-md-25">
            <label class="d-block text-black fw-semibold mb-10">
              Statut <span class="text-danger">*</span>
            </label>
            <Field name="statut" v-model="_statut" type="text" v-slot="{ field }">
              <Multiselect :searchable="true" :options="[
                { value: 0, label: 'Impayé' },
                { value: 1, label: 'Annulée ' },
                { value: 2, label: 'Normalisée' },
                { value: 3, label: 'Annulée' },
                { value: 4, label: 'Normalisée_P' },
                { value: 5, label: 'Avoir' }
              ]" v-model="field.value" v-bind="field" placeholder="Sélectionner le statut" />
            </Field>
          </div>
        </div>
        <div class="col">
          <div class="form-group mb-15 mb-sm-20 mb-md-25">
            <label class="d-block text-black fw-semibold mb-10">
              Mois
              <span class="text-danger">*</span>
            </label>
            <Field name="mois" v-model="_mois" type="text" v-slot="{ field }">
              <Multiselect :searchable="true" :options="[
                { value: 0, label: 'Janvier' },
                { value: 1, label: 'Février' },
                { value: 2, label: 'Mars' },
                { value: 3, label: 'Avril' },
                { value: 4, label: 'Mai' },
                { value: 5, label: 'Juin' },
                { value: 6, label: 'Juillet' },
                { value: 6, label: 'Aout' },
                { value: 7, label: 'Septembre' },
                { value: 8, label: 'Octobre' },
                { value: 9, label: 'Novembre' },
                { value: 10, label: 'Decembre' },
              ]" v-model="field.value" v-bind="field" placeholder="Sélectionner le mois" />
            </Field>
          </div>
        </div>


        <div class="col">
          <div class="form-group mb-15 mb-sm-20 mb-md-25">
            <label class="d-block text-black fw-semibold mb-10">
              Année
            </label>
            <Field name="annee" v-model="_annee" type="text" v-slot="{ field }">
              <Multiselect :options="_annees" :searchable="true" v-model="field.value" v-bind="field"
                placeholder="Sélectionner une année" />
            </Field>
            <ErrorMessage name="annee" class="text-danger" />
          </div>
        </div>
      </div>
    </div>
    </div>
    <!-- FIN -->
    <hr>

    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Date
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Montant
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Mois
              </th>
            
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Service
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Statut
              </th>
          
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0  pe-0">ACTIONS
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(facture, index) in factures" :key="index">
             
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ facture.date_facture }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ facture.montant_facture }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ moisNoms[parseInt(facture?.mois)] }} {{ facture?.annee }}
              </td>
             <!-- <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ facture?.service?.reference }}
              </td>-->
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ facture?.service?.libelle }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span :class="getStatutBadge(facture?.statut).badgeClass">
                  {{ getStatutBadge(facture.statut).text }}
                </span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary pe-0">
                <div class="dropdown">
                  <button class="btn btn-sm btn-primary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a v-if="(facture.statut == 0 || facture.statut == 1 || facture.statut == 3)" @click="openNewWindow(facture)" type="button" class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-send lh-1 me-8 position-relative top-1"></i>
                        Aperçu facture
                      </a>
                      <a v-if="(facture.statut == 2 || facture.statut == 4 || facture.statut == 5)" @click="openNewWindow2(facture)" type="button" class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-send lh-1 me-8 position-relative top-1"></i>
                        Aperçu facture
                      </a>
                    </li>
                <!--<li v-if="(facture.statut == 0 || facture.statut == 1 || facture.statut == 3)">
                      <a  @click="normaliser(facture)" type="button" class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-send lh-1 me-8 position-relative top-1"></i>
                        Normalisée la facture
                      </a>
                    </li>--> 
                    <li v-if="!facture.statut && facture.statut !== false">
                      <a href="javascript:void(0);" data-bs-target="#create-task" data-bs-toggle="modal"
                        @click="openModal(facture.id, facture.reference)"
                        class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-close lh-1 me-8 position-relative top-1"></i> Annuler
                      </a>
                    </li>
                 <!--<li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                        @click="suppression(facture.id, factures, 'factures', `Facture ${facture.id}`)">
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>-->  
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal fade" id="create-task" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">Voulez-vous annuler cette facture ?</h6>
              <button type="button" id="close-modal" class="btn-close" data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div class="modal-body px-4">
              <Form ref="depensesForm" @submit="addFactures" :validation-schema="facturesSchema">
                <div class="row gy-2">
                  <div class="col-md-4-3">
                    <label class="d-block fw-semibold mb-10">
                      Motif<span class="text-danger"></span>
                    </label>
                    <Field name="motifAnnuler" as="textarea" placeholder="Entrer l'observation"
                      class="form-control shadow-none rounded-0 text-black" />
                    <ErrorMessage name="motifAnnuler" class="text-danger" />
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="submit" class="btn btn-primary">Annuler</button>
                  <button type="button" class="btn btn-danger" aria-label="Close">
                    Fermer
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import Swal from "sweetalert2";
import { Facture } from "@/models/Facture";
import ApiService from "@/services/ApiService";
import { suppression, error, getUrlApiForFiles, success } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import Multiselect from '@vueform/multiselect';
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from 'yup';
import axios from 'axios';
export default defineComponent({
  name: "ListeFacture",
  components: {
    PaginationComponent,
    Form,
    Multiselect,
    Field
  },
  setup() {
    onMounted(() => {
      getAllFactures();
      getAllServices();


    });
    const facturesSchema = Yup.object().shape({
      motifAnnuler: Yup.string().required("Le motif est obligatoire"),
    });
    const facturesForm = ref(null);
    const factures = ref<Array<Facture>>([]);
    const facture = ref<Facture>();
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const _statut = ref('');
    const _service = ref('');
    const serviceOptions = ref();
    const _mois = ref('');
    const _annee = ref('');
    const services = ref();
    const factureForm = ref(null);
    const montant_facture = ref();
    const reference = ref();
    const service = ref();
    const servicesOptions = ref([]);

    const factureii = ref();
    const openModal = (id: number) => {
      factureii.value = id;
    };
    const _annees = ref(
      Array.from({ length: 5 }, (_, i) => {
        const year = new Date().getFullYear() + i;
        return { value: year, label: year.toString() };
      })
    );
    const handlePaginate = async ({ page_, limit_ }) => {
      try {
        page.value = page_;
        limit.value = limit_;
        await rechercher()
      } catch (error) {
        //
      }
    };
    const getStatutBadge = (statut: number) => {
  switch (statut) {
    case 0:
      return {
        text: "Impayé",
        badgeClass: "badge bg-danger text-white", 
      };
    case 1:
      return {
        text: "Annulée",
        badgeClass: "badge bg-warning text-dark", 
      };
    case 2:
      return {
        text: "Normalisée",
        badgeClass: "badge bg-info text-white", 
      };
    case 3:
      return {
        text: "Annulée",
        badgeClass: "badge bg-secondary text-white", 
      };
    case 4:
      return {
        text: "Normalisée_P ",
        badgeClass: "badge bg-success text-white", 
      };
    case 5:
      return {
        text: "Avoir",
        badgeClass: "badge bg-dark text-white", 
      };
    default:
    return {
        text: "",
        badgeClass: "badge bg-white text-danger", 
      };
  }
};

    const noOptionsTextAbb = ref("Tapez au moins trois caractères");
    const nooptions = "Aucun enregistrement trouvé";
    const noResultText = "Aucun enregistrement trouvé";
    const serviceSelect = async (value) => {
      const service = await axios.get(`/services/${value}`);
      const serviceD = service.data.data;
      const serviceData = service.data.data.serviceElements;
      var som = parseFloat(serviceD.loyer);
      serviceData.forEach(element => {
        som += element.prix * element.quantite;
      });
      montant_facture.value = som;
      console.log(service.data.data, "service")
      console.log(value, "service")
    };

    const normaliser = async(value)=>{
      try{
        const response = await axios.get(`/normalisationFacture/${value.id}`);
        if(response.data.code === 200){
          success(response.data.message);
          await getAllFactures();
        }
      }catch(err){
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message);
        } else {
          error('An unknown error occurred');
        }
      }
    }

    const addFactures = async (values, { resetForm }) => {
      values["id"] = factureii.value;
      values["statut"] = true;
      ApiService.put("/AnnulefacturesS/" + values.id, values)
        .then(({ data }) => {
          console.log('depense', data);
          if (data.code === 200) {
            success(data.message);
            resetForm();
            getAllFactures();
            triggerButtonClick("close-modal");
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };
    
    const fetchServices = async (key) => {
      try {
        const response = await axios.get(`/services/recherche/${key}`);
        const servicesData = response.data.data;
        console.log(response)
        serviceOptions.value = servicesData.map((service) => (
          {
            value: `${service.id}`,
            label: `${service.reference} - ${service?.codePlace}-[${service.nomMarchand}]`,
          }));
        if (serviceOptions.value.length == 0) {
          noOptionsTextAbb.value = noResultText;
        } else {
          noOptionsTextAbb.value = 'Tapez au moins trois caractères';
        }
        return serviceOptions.value;
      } catch (error) {
        //
      }
    }


    const getAllServices = async () => {
      try {
        const response = await ApiService.get("/all/services");
        const servicesData = response.data.data.data;
        console.log("Data", servicesData);
        servicesOptions.value = servicesData.map((service) => ({
          value: service.id,
          label: service.libelle,
        }));
      } catch (error) {
        //error(response.data.message)
      }
    };

    function triggerButtonClick(buttonId: string) {
      const button = document.getElementById(buttonId) as HTMLButtonElement;
      if (button) {
        button.click(); // Simule un clic
      } else {
        console.error(`Button with ID "${buttonId}" not found.`);
      }
    }
    function rechercher() {
      getAllFactures(page.value, limit.value, searchTerm.value, _service.value, _statut.value, _mois.value, _annee.value)
    }

    function getAllFactures(page = 1, limi = 10, searchTerm = '', _service = '', _statut = '', _mois = '', _annee = "") {
      return ApiService.get(`all/facturesS?page=${page}&limit=${limi}&service=${_service}&statut=${_statut}&mois=${_mois}&annee=${_annee}&mot=${searchTerm}&`)
        .then(({ data }) => {
          factures.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          console.log('dataNouveauFacture', data.data);
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }
    watch(_service, () => {
      rechercher();
    });
    watch(_statut, (newVal) => {
      if (newVal === undefined || newVal === null || newVal === '') {
        _statut.value = '';
        rechercher();
      } else {
        rechercher();
      }
    });
    watch(_mois, (newVal) => {
      if (newVal === undefined || newVal === null || newVal === '') {
        _mois.value = '';
        rechercher();
      } else {
        rechercher();
      }
    });
    watch(_annee, (newVal) => {
      if (newVal === undefined || newVal === null || newVal === '') {
        _annee.value = '';
        rechercher();
      } else {
        rechercher();
      }
    });
    function moddifier(Editfactures: Facture) {
      facture.value = Editfactures;
    }
    const getMonthName = (monthNumber) => {
      const months = [
        "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
        "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
      ];
      return months[monthNumber] || "Mois inconnu";
    };
    const openAndPrint = (url: string) => {
      const newWindow = window.open(url, "_blank");
      if (newWindow) {
        newWindow.onload = () => {
          newWindow.print();
        };
      } else {
        console.error("Impossible d'ouvrir la fenêtre");
      }
    };
    function openNewWindow(data: any, dossier = "Facture") {
      openAndPrint(getUrlApiForFiles(dossier, data.reference + ".pdf"));
    }
    function openNewWindow2(data: any, dossier = "Facture_Normalisees") {
      openAndPrint(getUrlApiForFiles(dossier, data.reference + ".pdf"));
    }
    const deleteFacture = (id: number) => {
      ApiService.delete(`/facturesS/${id}`)
        .then(({ data }) => {
          Swal.fire({
            text: data.message,
            toast: true,
            icon: 'success',
            title: 'General Title',
            animation: false,
            position: 'top-right',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            heightAuto: false
          });
        })
        .catch(({ response }) => {
          Swal.fire({
            text: response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Réssayer à nouveau!",
            heightAuto: false,
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
      for (let i = 0; i < factures.value.length; i++) {
        if (factures.value[i].id === id) {
          factures.value.splice(i, 1);
        }
      }
    };
    const annulerFacture = (id: number, reference: string) => {
      Swal.fire({
        title: "Confirmation",
        text: `Voulez-vous vraiment annuler la facture ${reference} ?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Annuler",
        cancelButtonText: "Retour"
      }).then((result) => {
        if (result.isConfirmed) {
          ApiService.put(`/AnnulefacturesS/${id}`, {})
            .then(({ data }) => {
              Swal.fire({
                title: "Annulé",
                text: "La facture a été annulée avec succès.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false
              });
              getAllFactures(page.value, limit.value, searchTerm.value);
            })
            .catch(({ response }) => {
              Swal.fire({
                title: "Erreur",
                text: response.data.message || "Une erreur est survenue.",
                icon: "error",
                confirmButtonText: "Ok"
              });
            });
        }
      });
    };
    /*const getAllServices = async () => {
      try {
        const response = await ApiService.get('/all/services');
        const servicesData = response.data.data.data;
        console.log('Data', servicesData)
        serviceOptions.value = servicesData.map((service) => ({
          value: servicesData.id,
          label: service.reference,
        }));
      }
      catch (error) {
        //error(response.data.message)
      }
    }*/
    const moisNoms = [
      "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
      "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
    ];
    function formatPeriode(periode: string): string {
      if (!periode) return "";
      const [year, month] = periode.split("-");
      return `${moisNoms[parseInt(month, 10) - 1]} ${year}`;
    }
    const privileges = ref<Array<string>>(JwtService.getPrivilege());
    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }
    return {
      factures,
      checkPermission,
      getAllFactures,
      deleteFacture,
      moddifier,
      suppression,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      rechercher,
      searchTerm,
      getStatutBadge,
      annulerFacture,
      moisNoms,
      _service,
      _statut,
      servicesOptions,
      getMonthName,
      _annees,
      _annee,
      _mois,
      openNewWindow,
      fetchServices,
      nooptions,
      noOptionsTextAbb,
      serviceSelect,
      normaliser,
      openModal,
      openNewWindow2,
      addFactures

    };
  },
});
</script>
